fragment StaffQuizAttemptFields on StaffQuizAttempt {
  id
  moduleSlug
  startedAt
  expiresAt
  submittedAt
  score
  passed
  passMark
  questions {
    id
    prompt
    options {
      id
      text
    }
  }
  review {
    questionId
    prompt
    options {
      id
      text
    }
    selectedOptionId
    correctOptionId
    correct
    explanation
  }
}
